<template>
  <TemplateDemandBooking1 v-if="isReadyToDraw" :busStops="busStops" />

  <DialogInitialLoading v-else />
</template>

<script>
import API from "@/API";
import nativeHandlerService from "@/services/nativeHandler";
import TemplateDemandBooking1 from "@/views/Templates/Demand/TemplateDemandBooking1"
import { onMounted } from "vue";
import { ref } from "vue";

export default {
  name: "booking1",
  components: {
    TemplateDemandBooking1,
  },
  setup() {
    const busStops = ref(null)
    const isReadyToDraw = ref(false);

    onMounted(async () => {
      nativeHandlerService.demand.ncSetDemandIndex(1);

      // バス停取得API
      busStops.value = await API.getDemandBusStops()

      isReadyToDraw.value = true;

    });
    return {
      busStops,
      isReadyToDraw,

    }
  }
};
</script>